import React from 'react';1
import { QuestionBubbleProps } from './types';

const QuestionBubble = ({ size = 'sm' }: QuestionBubbleProps) => {
    if (size === 'lg') {
        return (
            <div className="question-bubble lg">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="60.659"
                    height="67.433"
                    viewBox="0 0 60.659 67.433"
                >
                    <defs>
                        <linearGradient
                            id="linear-gradient-lg"
                            x1="0.771"
                            y1="1.124"
                            x2="0.31"
                            y2="0.37"
                            gradientUnits="objectBoundingBox"
                        >
                            <stop offset="0" stopColor="#f7a600" />
                            <stop offset="1" stopColor="#ffd618" />
                        </linearGradient>
                    </defs>
                    <g
                        id="help-bubble"
                        transform="translate(-42.791)"
                        style={{ isolation: 'isolate' }}
                    >
                        <path
                            id="Path_3924-lg"
                            data-name="Path 3924"
                            d="M58.053,18.043A30.084,30.084,0,0,0,40.593,1.766,29.634,29.634,0,0,0,30.493,0,30.661,30.661,0,0,0,2.124,19.159,30.32,30.32,0,0,0,14.005,55.842l-1.2,2.881a6.294,6.294,0,0,0,8.232,8.225l20.643-8.568A30.295,30.295,0,0,0,58.053,18.043"
                            transform="translate(42.79 0)"
                            fill="url(#linear-gradient-lg)"
                        />
                    </g>
                </svg>
            </div>
        );
    }
    return (
        <div className="question-bubble sm">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="46.563"
                height="51.762"
                viewBox="0 0 46.563 51.762"
            >
                <defs>
                    <linearGradient
                        id="linear-gradient-sm"
                        x1="0.771"
                        y1="1.124"
                        x2="0.31"
                        y2="0.37"
                        gradientUnits="objectBoundingBox"
                    >
                        <stop offset="0" stopColor="#f7a600" />
                        <stop offset="1" stopColor="#ffd618" />
                    </linearGradient>
                </defs>
                <g id="help-bubble-mobile" transform="translate(0 0)">
                    <path
                        id="Path_3924-sm"
                        data-name="Path 3924"
                        d="M44.562,13.85A23.093,23.093,0,0,0,31.16,1.356,22.748,22.748,0,0,0,23.407,0,23.536,23.536,0,0,0,1.63,14.706a23.274,23.274,0,0,0,9.12,28.159l-.918,2.212a4.831,4.831,0,0,0,6.319,6.314L32,44.814A23.255,23.255,0,0,0,44.562,13.85"
                        transform="translate(0 0)"
                        fill="url(#linear-gradient-sm)"
                    />
                </g>
            </svg>
        </div>
    );
}

export default QuestionBubble;
